'use strict';

var AP = {};

// Mobile Detect
AP.isMobile = device.mobile();

// Features Detect Support
feature.touch ? $('html').addClass('touch') : $('html').addClass('no-touch');
// setTimeout(function () {
//     $('body').addClass('is-loaded');
// }, 1000);
$(document).ready(function () {

    // Show 'body' after load page

    // Object Fit Polyfill
    // objectFit.polyfill({
    //     selector: '.obj-fit',
    //     fittype: 'cover',
    //     disableCrossDomain: 'true'
    // });

});

function number_format(number, decimals, dec_point, thousands_sep) {
    // Format a number with grouped thousands
    //
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://crestidg.com)

    var i, j, kw, kd, km;

    // input sanitation & defaults
    if (isNaN(decimals = Math.abs(decimals))) {
        decimals = 2;
    }
    if (dec_point == undefined) {
        dec_point = ",";
    }
    if (thousands_sep == undefined) {
        thousands_sep = ".";
    }

    i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

    if ((j = i.length) > 3) {
        j = j % 3;
    } else {
        j = 0;
    }

    km = (j ? i.substr(0, j) + thousands_sep : "");
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
    //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
    kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");
    return km + kw + kd;
}

(function ($, window, document, undefined) {

    $(document).ready(function () {

        // Scroll To
        $('[data-to-id]').on('click', function (e) {
            e.preventDefault();
            var id = $(this).data('to-id');
            var offset_custom = $(this).data('offset') ? $(this).data('offset') : 30;
            $('html, body').animate({
                scrollTop: $('#' + id).offset().top - offset_custom
            }, 1000);
        });

        // Show Block
        $('[data-show-block]').on('click', function (e) {
            if ($(this).attr('href')) {
                e.preventDefault();
            }
            if ($(this).data('hidden')) {
                $(this).fadeOut();
            }
            var hasErrors = ($(this).parents().find('form .error').length > 0) ? true : false;

            if (!hasErrors) {
                var id = $(this).data('show-block');
                $('#' + id).slideDown();
            }
        });

        $('.show-station-address').on('click', function (e) {
            e.preventDefault();

            let $box = $('#box-address-items');
            let $arrow = $('#header_arrow');

            $box.toggleClass('show');
            $arrow.toggleClass('header_opened');

            return false;
        });

        $('.as-list').on('click', function (e) {
            e.preventDefault();

            let $list = $('#header-station-list');
            let $map = $('#header-station-map');
            let $mapButton = $('.on-map');
            let $listButton = $('.as-list');

            $list.removeClass('hidden');
            $map.addClass('hidden');

            $listButton.addClass('selected');
            $mapButton.removeClass('selected');

            return false;
        });

        $('.on-map').on('click', function (e) {
            e.preventDefault();

            let $list = $('#header-station-list');
            let $map = $('#header-station-map');
            let $mapButton = $('.on-map');
            let $listButton = $('.as-list');

            $list.addClass('hidden');
            $map.removeClass('hidden');

            $listButton.removeClass('selected');
            $mapButton.addClass('selected');
            return false;
        });

        $('.schedule-button').on('click', function (e) {
            let $sheduleList = $('#desktop-header-shedule-info');
            let $backDrop = $('.schedule .backdrop-hidden');

            $sheduleList.removeClass('hidden').delay(350);
            $backDrop.addClass('backdrop').delay(350);

            return false;
        });

        $('.city-button').on('click', function (e) {
            let $citiesList = $('#desktop-header-cities');
            let $backDrop = $('.cities .backdrop-hidden');

            $citiesList.removeClass('hidden').delay(350);
            $backDrop.addClass('backdrop').delay(350);

            return false;
        });

        $('.city-list-item-name').on('click', function (e) {
          const cityId = $(this).data('city-id');
          $.ajax({
            'async': false,
            'url': "/ajax/change-city",
            'method': "POST",
            'data': "cityId=" + cityId + "&_csrf=" + $("#_csrf").val(),
            'dataType': "json",
            'success': function () {
              location.reload();
            },
            'error': function (jqXhr, textStatus, errorMessage) {
              console.log({jqXhr, textStatus, errorMessage});
            }
          });
        });

        $('.close-button').on('click', function (e) {
            let $list = $('#desktop-header-shedule-info, #desktop-header-cities, #desktop-header-city-confirm');
            let $backDrop = $('.backdrop-hidden, .city-confirm-backdrop');

            $list.addClass('hidden');
            $backDrop.removeClass('backdrop');

            return false;
        });

        $('.city-confirm-button').on('click', function (e) {
          let $container = $('#desktop-header-city-confirm');
          let $backDrop = $('.city-confirm-backdrop');

          $container.addClass('hidden');
          $backDrop.removeClass('backdrop');

          return false;
        });

        $('.city-change-button').on('click', function (e) {
          let $confirm = $('#desktop-header-city-confirm');
          let $cities = $('#desktop-header-cities');
          let $confirmBackdrop = $('.city-confirm-backdrop');
          let $citiesBackdrop = $('.cities .backdrop-hidden');

          $confirm.addClass('hidden');
          $cities.removeClass('hidden');
          $confirmBackdrop.removeClass('backdrop');
          $citiesBackdrop.addClass('backdrop');

          return false;
        });

        $('.backdrop-hidden').on('click', function (e) {
            let $list = $('#desktop-header-shedule-info, #desktop-header-cities');
            let $backDrop = $('.backdrop-hidden');

            $list.addClass('hidden');
            $backDrop.removeClass('backdrop');

            return false;
        });

        $('.city-confirm-backdrop').on('click', function (e) {
            let $container = $('#desktop-header-city-confirm');
            let $backdrop = $('.city-confirm-backdrop');

            $container.addClass('hidden');
            $backdrop.removeClass('backdrop');

            return false;
        });

        $('.adresses').on('click', function (e) {

            let $list = $('#desktop-header-station-list');
            let $map = $('#desktop-header-station-map');
            let $arrow = $('#header_dark_arrow');

            $map.addClass('hidden');
            $list.toggleClass('hidden');
            $arrow.toggleClass('header_closed');

            return false;
        });

        $('.show-on-map').on('click', function (e) {
            let $arrow = $('#header_dark_arrow');
            let $list = $('#desktop-header-station-list');
            let $map = $('#desktop-header-station-map');

            $arrow.addClass('header_closed');
            $list.addClass('hidden');
            $map.toggleClass('hidden');

            return false;
        });

        // Mobile Menu Trigger
        var mainMenu = $('#mainMenu');
        var btnMenuToggle = $('#menuToggler');
        var overlayMenu = $('<div>').addClass('b-overlay b-overlay_menu').hide();
        var overlayAddress = $('<div>').addClass('b-overlay b-overlay_address').hide();
        var triggerMenu = function triggerMenu() {
            var func = function () {
                mainMenu.removeClass('is-opened').slideUp(200);
                $('body').removeClass('is-menu-open');
                overlayMenu.fadeOut(200);
                overlayAddress.fadeOut(200);
                setTimeout(function () {
                    overlayMenu.remove();
                    overlayAddress.remove();
                }, 200)
            };
            var close = function () {
                if (mainMenu.hasClass('is-opened')) {
                    func();
                    accordeonItems.close();
                }
            };
            return {func: func, close: close}
        }();

        $(window).resize(function () {
            if (mainMenu.hasClass('is-opened')) {
                mainMenu.css({'top': btnMenuToggle[0].offsetTop + btnMenuToggle[0].offsetHeight});
            }
        });

        btnMenuToggle.on('click', function () {
            if (!mainMenu.hasClass('is-opened')) {
                triggerSidebar.close();
                overlayMenu.appendTo('main.b-main.b-main_inner').fadeIn();
                overlayAddress.appendTo('.b-header_address-btn').fadeIn();
                mainMenu.css({'top': btnMenuToggle[0].offsetTop + btnMenuToggle[0].offsetHeight}).addClass('is-opened').slideDown();
                $('body').addClass('is-menu-open');
                overlayMenu.on('click', function () {
                    triggerMenu.close();
                });
                overlayAddress.on('click', function () {
                    triggerMenu.close();
                });
            } else {
                triggerMenu.func();
                accordeonItems.close();
            }
        });

        var innerItemMenu = mainMenu.find('.b-header_menu-inner');
        var accordeonItems = function accordeonItems() {
            var init = function () {
                innerItemMenu.hide();
                mainMenu.find('.b-header_menu-item').each(function () {
                    var childLink = $(this).children('a');
                    if (childLink.next().length) {
                        childLink.on('click', function (e) {
                            e.preventDefault();
                            $(this).toggleClass('is-current');
                            $(this).next().slideToggle();
                        });
                    }
                });
            };
            var destroy = function () {
                mainMenu.find('.b-header_menu-item').each(function () {
                    var childLink = $(this).children('a');
                    if (childLink.next().length) {
                        childLink.off('click');
                        childLink.next().removeAttr('style');
                    }
                });
            };
            var close = function () {
                mainMenu.find('.b-header_menu-item').each(function () {
                    var childLink = $(this).children('a');
                    if (childLink.hasClass('is-current')) {
                        childLink.removeClass('is-current');
                        childLink.next().slideUp();
                    }
                });
            };
            return {init: init, destroy: destroy, close: close}
        }();

        // Search filter in item menu
        mainMenu.find('.item-search').on('keyup', 'input', function () {
            var value = this.value.toLowerCase();
            var fields = $(this).parent('.item-search').next('.b-form').find('.b-form_field');
            fields.each(function () {
                // if ($(this).find('label').text().search(value) > -1) {
                //     $(this).not('.hidden').show();
                // } else {
                //     $(this).hide();
                // }
                if ($(this).find('a').attr('title').search(value) > -1) {
                    $(this).not('.hidden').show();
                } else {
                    $(this).hide();
                }
            });
            if ($(this).parent('.item-search').next('.b-form').find('.b-form_field:visible').length === 0) {
                if ($('.is-not-found').length === 0) {
                    $(this).parent('.item-search').next('.b-form').append('<div class="is-not-found">Ничего не найдено</div>');
                }
            } else {
                $('.is-not-found').remove();
            }
        });

        innerItemMenu.on('click', '.btn-cancel', function (e) {
            e.preventDefault();
            var thisList = $(this).parent().prev('.inner-search-list');
            thisList.find('input').prop('checked', false);
            if (thisList.find('.item-search').find('input').val().length > 0) {
                thisList.find('.item-search').find('input').val('');
                thisList.find('.b-form_field').show();
                thisList.find('.is-not-found').remove();
            }
        });

        //Services search big menu
        var arMenuLinks = {};
        $('.service-big .item-search').on('focus', 'input', function () {
            $('.service-big .row').hide('fast');

            if (!Object.keys(arMenuLinks).length) {
                $('.service-big .row a').each(function () {
                    if ($(this).attr('href') != "#") {
                        arMenuLinks[$(this).attr('href')] = $(this).text();
                    }
                });

                for (var key in arMenuLinks) {
                    if (arMenuLinks.hasOwnProperty(key)) {
                        $('.service-big .service-big-search-result').append('<div class="b-form_field"><a href="' + key + '" title="' + arMenuLinks[key].toLowerCase() + '">' + arMenuLinks[key] + '</a></div>');
                    }
                }
            }

            $('.service-big .service-big-search-result').css('max-height', $(".services-menu").height()).show('fast');
        });
        $('.service-big .item-search').on('blur', 'input', function () {
            setTimeout(function () {
                $('.service-big .row').show('fast');
                $('.service-big .service-big-search-result').hide('fast');
            }, 200);
        });
        $('.service-big .item-search').on('keyup', 'input', function () {
            var value = this.value.toLowerCase();
            var fields = $('.service-big-search-result .b-form_field');
            fields.each(function () {
                if ($(this).find('a').attr('title').search(value) > -1) {
                    $(this).not('.hidden').show();
                } else {
                    $(this).hide();
                }
            });
            if ($('.service-big-search-result .b-form_field:visible').length === 0) {
                if ($('.service-big-search-result .is-not-found').length === 0) {
                    $('.service-big-search-result').append('<div class="is-not-found">Ничего не найдено</div>');
                }
            } else {
                $('.service-big-search-result .is-not-found').remove();
            }
        });

        // Sidebar Trigger
        var sidebar = $('#sidebar');
        var btnOpenSidebar = $('#openSidebar');
        var overlaySidebar = $('<div>').addClass('b-overlay b-overlay_sidebar').hide();
        var triggerSidebar = function triggerMenu() {
            var open = function () {
                overlaySidebar.appendTo('body').fadeIn();
                $('body').addClass('is-sidebar-open');
            };
            var close = function () {
                $('body').removeClass('is-sidebar-open');
                overlaySidebar.fadeOut(400);
                setTimeout(function () {
                    overlaySidebar.remove();
                }, 400)
            };
            return {open: open, close: close}
        }();

        btnOpenSidebar.on('click', function () {
            triggerMenu.close();
            triggerSidebar.open();
            overlaySidebar.on('click', function () {
                triggerSidebar.close();
            });
        });

        enquire.register("screen and (min-width: 1100px)", {
            match: function () {
                overlayMenu.remove();
                overlayAddress.remove();
                overlaySidebar.remove();
                triggerMenu.close();
                triggerSidebar.close();
                innerItemMenu.find('.inner-search-list').perfectScrollbar({
                    suppressScrollX: true
                });
            },
            unmatch: function () {
                innerItemMenu.find('.inner-search-list').perfectScrollbar('destroy');
            }
        });

        enquire.register("screen and (max-width: 1099px)", {
            match: function () {
                accordeonItems.init();
            },
            unmatch: function () {
                accordeonItems.destroy();
            }
        });

        // Show fixed menu
        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 200) {
                $('#fixedMenu').fadeIn(200);
            } else {
                $('#fixedMenu').fadeOut(200);
            }
        });

        // Tag Sort
        //$('#filterItems').tagSort({
        //    items:'.b-page_blog-item',
        //    tagClassPrefix: false,
        //    sortType: 'single',
        //    reset: '#button-tags-reset'
        //});

        $('button,.filter-item').on('click', function () {
            var el = $(this).children().first();
            if (el.get(0) && el.get(0).tagName == 'A')
                location.href = el.attr('href');
        });

        $('.b-page_catalog-item').hover(function () {
            $('.b-page_catalog-item').removeClass('is-active');
            $(this).addClass('is-active');
        }, function () {
            $('.b-page_catalog-item').removeClass('is-active');
        });

        // Add File Name
        function addFileName(currentEl) {
            var str = currentEl.val();
            var i = str.lastIndexOf('\\') ? str.lastIndexOf('\\') + 1 : str.lastIndexOf('/') + 1;
            var filename = str.slice(i);
            return filename;
        }

        // Add Photo Ocenka
        function initInputFileAddPhoto() {
            $('input[data-type-file="photo"]').on('change', function () {
                $(this).hide();
                $(this).next().remove();
                $(this).parent().append('<span class="b-add-photo_name">' + addFileName($(this)) + ' <a href="#" class="b-remove-photo_name">x</a></span>');
                $(this).parent().find('.btn_rmv').remove();
            });
        }

        initInputFileAddPhoto();

        var photoItems = $('.b-add-photo_items');
        var tempBtnLoad;
        $('#addMorePhoto').on('click', function () {
            var idNumber = Math.floor(Math.random() * 1000);
            tempBtnLoad = $('<label class="b-add-photo_btn" for="loadPhoto' + idNumber + '">' +
                '<input id="loadPhoto' + idNumber + '" type="file" name="photos[]" data-type-file="photo">' +
                '<span class="e-btn e-btn_red">Загрузи фото</span>' +
                ' <a href="#" class="b-remove-photo_name btn_rmv">x</a></label>');
            tempBtnLoad.appendTo(photoItems);
            initInputFileAddPhoto();
        });

        $('div.b-add-photo_items').on('click', 'a.b-remove-photo_name', function () {
            $(this).closest('.b-add-photo_btn').remove();
            return false;
        });

        // Input File
        $('input[data-type-file="file"]').on('change', function () {
            var currentText = $(this).siblings('.b-form_file-text').text();
            var filename = addFileName($(this));
            filename.length ? $(this).siblings('.b-form_file-text').text(filename) : $(this).siblings('.b-form_file-text').text(currentText);
        });

        // Form Validator
        if ($('input[type="tel"]').length) {
            $('input[type="tel"]').mask('+7 (000) 000-00-00', {placeholder: "+7 ( ___ ) ___ - __ - __"});
        }

        $('#ocenkaForm').validate({
            rules: {
                name: {
                    minlength: 2,
                    maxlength: 255
                },
                phone: {
                    required: true,
                    phone: true
                },
                email: {
                    maxlength: 128,
                    email: true
                },
            },
            messages: {
                name: {
                    minlength: jQuery.validator.format("Слишком короткое имя"),
                    maxlength: jQuery.validator.format("Слишком длинное имя"),
                    required: "Обязательное поле"
                },
                phone: {
                    required: "Обязательное поле",
                },
                email: {
                    maxlength: jQuery.validator.format("Слишком длинный email"),
                    required: "Обязательное поле"
                }
            }
        });

        $('#orderOnAddForm').validate({
            rules: {
                mark: {
                    required: true
                },
                model: {
                    required: true
                },
                engine: {
                    required: true
                },
                oil: {
                    required: true
                },
            },
            messages: {
                mark: {
                    required: "Обязательное поле",
                },
                model: {
                    required: "Обязательное поле",
                },
                engine: {
                    required: "Обязательное поле",
                },
                oil: {
                    required: "Обязательное поле",
                },
            }
        });

        $('.order-on-form').validate({
            rules: {
                name: {
                    minlength: 2,
                    maxlength: 255
                },
                phone: {
                    required: true,
                    phone: true
                }
            },
            messages: {
                name: {
                    minlength: jQuery.validator.format("Слишком короткое имя"),
                    maxlength: jQuery.validator.format("Слишком длинное имя"),
                    required: "Обязательное поле"
                },
                phone: {
                    required: "Обязательное поле",
                }
            }
        });

        $('.price-filter').validate({
            rules: {
                mark: {
                    required: true
                },
                model: {
                    required: true
                }
            },
            messages: {
                mark: {
                    required: "Обязательное поле"
                },
                model: {
                    required: "Обязательное поле"
                }
            }
        });

        $('#formReviews').validate({
            rules: {
                rating: {
                    required: true,
                },
                body: {
                    required: true,
                },
                name: {
                    required: true,
                },
                email: {
                    required: true,
                    maxlength: 128,
                    email: true
                }
            },
            messages: {
                rating: {
                    required: "Выберите звезду"
                },
                body: {
                    required: "Обязательное поле",
                },
                name: {
                    required: "Обязательное поле",
                },
                email: {
                    required: "Обязательное поле",
                    maxlength: jQuery.validator.format("Слишком длинный email"),
                }
            }
        });

        jQuery.validator.addMethod("phone", function (value, element) {
            return this.optional(element) || /^((\+7)[\s]?)?(\(?\d{3}\)?[\s]?)?([\d\ ]{2,3})([\-]\d{2})([\-]\d{2})$/im.test(value);
        }, "Неверный формат номера телефона");

        jQuery.validator.addMethod("email", function (value, element) {
            return this.optional(element) || /^[-a-z0-9!#$%&'*+\/=?^_`{|}~]+(?:\.[-a-z0-9!#$%&'*+\/=?^_`{|}~]+)*@(?:[a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?\.)*(?:aero|arpa|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|[a-z][a-z])$/.test(value);
        }, "Неправильный адрес электронной почты");

        // Show Checkboxes
        $('.b-form_show-btn').on('click', 'button', function () {
            var text = $(this).text();
            $(this).parent().prev('.b-form_hidden-block').slideToggle();
            if ($(this).text() === $(this).data('visible-text')) {
                $(this).text($(this).data('hidden-text'));
            } else {
                $(this).text($(this).data('visible-text'));
            }
        });

        // Datetimepicker
        $.datetimepicker.setLocale('ru');

        $('.b-form_datetimepicker').datetimepicker({
            format: 'd.m.Y H:i',
            inline: true,
            todayButton: false,
            timepickerScrollbar: false,
            dayOfWeekStart: 1,
            minDate: 0,
            scrollMonth: feature.touch ? false : true,
            scrollTime: feature.touch ? false : true,
            scrollInput: feature.touch ? false : true
        }).datetimepicker('reset');

        // Scroll Block
        var scrollBlock = $('.is-scroll-block, .dropdown-toggle + .dropdown-menu');
        $(window).on('resize', function () {
            scrollBlock.perfectScrollbar('update');
        });
        // enquire.register("screen and (max-width: 1280px)", {
        //     match : function() {
        //         scrollBlock.perfectScrollbar({
        //             suppressScrollY: true
        //         });
        //     },
        //     unmatch : function() {
        //         scrollBlock.perfectScrollbar('destroy');
        //     }
        // });

        // Slider Single Blog
        $('.b-slider_items').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="ic-big-arrow-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="ic-big-arrow-right"></i></button>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 639,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }
            ]
        });

        // Repair Labels Cars
        $('.b-page_repair-list_items').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow: '<button type="button" class="slick-prev"><i class="ic-big-arrow-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="ic-big-arrow-right"></i></button>',
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 479,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 639,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }, {
                    breakpoint: 979,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6
                    }
                }, {
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: 8,
                        slidesToScroll: 8
                    }
                }
            ]
        });

        // Tags
        $('.b-tags').on('click', '.e-btn', function () {
            $(this).prev().find('.items-hidden').slideDown();
        });
        $('.b-tags-popular').on('click', '.e-btn', function () {
            $(this).prev().find('.items-hidden').slideToggle();
            $(this).toggleClass('active_but');
        });

        $('.b-main_inner').on('click', '.show_specialize_but', function () {
            if (!$(this).hasClass("active")) {
                $(this).addClass('active').html('Скрыть');
                $(this).closest('.b-tags-specialize').find('a.hidden').addClass("visible").removeClass("hidden");
            } else {
                $(this).removeClass('active').html('Показать все');
                $(this).closest('.b-tags-specialize').find('a.visible').removeClass("visible").addClass("hidden");
            }

            return false;
        });

        // Lightbox
        $('[rel="lightbox"]').simpleLightbox();

        // Rating
        $('.b-rating_set').on('click', '.b-rating_item', function () {
            $(this).parent().find('.b-rating_item').removeClass('active');
            $(this).addClass('active');
            $('#formRating').val($(this).data('rating-num'));
            if ($(this).nextAll().length) {
                $(this).nextAll().addClass('active');
            }
        });

        // GMap
        var infoWindows = [];
        if ($('.gm-map').data('single-address')) {
            //var map = $('.gm-map');

            var data = {
                address: $('.gm-map').data('single-address'),
                title: $('.gm-map').data('single-title'),
                lng: $('.gm-map').data('single-lng'),
                lat: $('.gm-map').data('single-lat'),
                link: $('.gm-map').data('single-link')
            };

            var elemMap = document.getElementById("single-station"),
                center = new google.maps.LatLng(data.lng, data.lat),
                mapOptions = {
                    center: center,
                    zoom: 16,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_TOP
                    },
                    mapTypeControl: false,
                    panControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    draggable: feature.touch ? false : true,
                    overviewMapControl: false
                };

            var map = new google.maps.Map(elemMap, mapOptions);
            var marker = new google.maps.Marker({
                map: map,
                title: '<div>' + data.title + '</div><br>' + data.address + '<br><div style="padding-top:10px"><a style="color: #514158;border-color: #514158" href="' + data['link'] + '">Перейти</a></div>',
                position: new google.maps.LatLng(data.lng, data.lat),
                icon: {
                    url: '/images/core/placeholder-map.svg'
                }
            });
            infoBox(map, marker);
        } else {
            multipleMarkers();
        }

        function multipleMarkers() {
            var center = new google.maps.LatLng(55.757351, 37.617906),
                mapOptions = {
                    center: center,
                    zoom: 9,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_TOP
                    },
                    mapTypeControl: false,
                    panControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    draggable: feature.touch ? false : true,
                    overviewMapControl: false
                };

            var elemMap = document.getElementById("mapMultiple");

            if (elemMap) {
                var map = new google.maps.Map(elemMap, mapOptions);
                setMarkers(center, map);

                google.maps.event.addDomListener(window, 'resize', function () {
                    var center = map.getCenter();
                    google.maps.event.trigger(map, "resize");
                    map.setCenter(center);
                });
            }
        }

        function setMarkers(center, map) {
            var geocoder = new google.maps.Geocoder();
            var json = (function () {
                var json = null;

                var params = '';
                var station = $('.b-wrapper').attr('data-station');
                var region = $('.b-wrapper').attr('data-region');
                var mark = $('.b-wrapper').attr('data-mark');
                var model = $('.b-wrapper').attr('data-model');
                var service = $('.b-wrapper').attr('data-service');

                if (station !== undefined)
                    params += '&station=' + station;
                if (region !== undefined)
                    params += '&region=' + region;
                if (mark !== undefined)
                    params += '&mark=' + mark;
                if (model !== undefined)
                    params += '&model=' + model;
                if (service !== undefined)
                    params += '&service=' + service;

                if (params != '')
                    params = '?' + params.substr(1);

                $.ajax({
                    'async': false,
                    'global': false,
                    'url': "/api/v1/addresses" + params,
                    //'url': "./addresses.json",
                    'dataType': "json",
                    'success': function (data) {
                        json = data;
                    }
                });
                return json;
            })();

            for (var i = 0, length = json.length; i < length; i++) {
                var data = json[i];
                var marker = new google.maps.Marker({
                    map: map,
                    title: '<div style="font-weight: bold;font-size: 16px;">' + data['title'] + '</div><br>' + data['address'] + '<br><div style="padding-top:10px"><a style="color: #514158;border-color: #514158" href="' + data['link'] + '">Перейти</a></div>',
                    position: new google.maps.LatLng(data['lng'], data['lat']),
                    icon: {
                        url: '/images/core/placeholder-map.svg'
                    }
                });
                infoBox(map, marker);
            }

            if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function (pos) {
                var me = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);

                var marker = new google.maps.Marker({
                    map: map,
                    title: '<div style="font-weight: bold;font-size: 16px;">Вы тут!</div>',
                    position: me,
                    icon: {
                        url: '/images/core/me.png'
                    }
                });
                infoBox(map, marker);

            }, function (error) {
//                console.log(error);
            });
        }

        function infoBox(map, marker) {
            var infoWindow = new google.maps.InfoWindow({
                content: marker.title
            });

            infoWindows.push(infoWindow);

            google.maps.event.addListener(marker, "click", function (e) {
                for (var i = 0; i < infoWindows.length; i++) {
                    infoWindows[i].close();
                }
                infoWindow.open(map, marker);
            });

            (function (marker) {
                google.maps.event.addListener(marker, "click", function (e) {
                    for (var i = 0; i < infoWindows.length; i++) {
                        infoWindows[i].close();
                    }
                    infoWindow.open(map, marker);
                });
            })(marker);

            google.maps.event.addListener(map, 'click', function () {
                infoWindow.close();
            });
        }
    });

    function number_format(number, decimals, dec_point, thousands_sep) {  // Format a number with grouped thousands
        //
        // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
        // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +     bugfix by: Michael White (http://crestidg.com)

        var i, j, kw, kd, km;

        // input sanitation & defaults
        if (isNaN(decimals = Math.abs(decimals))) {
            decimals = 2;
        }
        if (dec_point == undefined) {
            dec_point = ",";
        }
        if (thousands_sep == undefined) {
            thousands_sep = ".";
        }

        i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

        if ((j = i.length) > 3) {
            j = j % 3;
        } else {
            j = 0;
        }

        km = (j ? i.substr(0, j) + thousands_sep : "");
        kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
        //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
        kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

        return km + kw + kd;
    }

    $('body').on('click', '.e-buy', function () {
        if ($(this).hasClass('active'))
            return false;

        var code = $(this).parent().parent().find('input[name="code"]').val();
        var totalBlock = $(this).parent().parent().parent().parent().find('.total-cost');

        var num = $(this).parent().find('.list-view_price').text();
        num = num.replace(/от/g, '');
        num = num.replace(/руб/g, '');
        num = num.replace(/\./g, '');
        num = num.replace(/\s/g, '');
        num = num.replace(/,/g, '.');

        var groupCost = totalBlock.text();
        groupCost = groupCost.replace(/от/g, '');
        groupCost = groupCost.replace(/руб/g, '');
        groupCost = groupCost.replace(/\./g, '');
        groupCost = groupCost.replace(/\s/g, '');
        groupCost = groupCost.replace(/,/g, '.');
        groupCost = parseFloat(groupCost) + parseFloat(num);

        var serviceID = $(this).data('id');
        var optionElement = $('.selectpicker option[value="' + serviceID + '"]');
        var optionIndex = $('.selectpicker option').index(optionElement) + 2;

        var id = '.dropdown-menu #item_' + optionIndex;

        if ($(id).hasClass('selected')) {
            $(id).addClass('selected');
        } else {
            $(id).find('a').click();
        }
        ;

        // var link = $(this);
        var link = $(this).parent().find('.btn-view.e-buy');
        $.ajax({
            'async': false,
            'global': false,
            'url': "/cart/add",
            'method': "POST",
            'data': "code=" + code + "&_csrf=" + $("#_csrf").val(),
            'dataType': "json",
            'success': function (data) {

                totalBlock.text(number_format(groupCost, 2, ',', ' ') + ' руб.');

                var sum = 0;
                $('.total-cost').each(function () {
                    var num = $(this).html();
                    num = num.replace(/от/g, '');
                    num = num.replace(/руб/g, '');
                    num = num.replace(/\./g, '');
                    num = num.replace(/\s/g, '');
                    num = num.replace(/,/g, '.');
                    sum += Number(num)
                });

                $('.calc-price .b-inner strong').text(number_format(sum, 2, ',', ' ') + ' руб.');

                // $('.calc-price .b-inner strong').text(number_format(data.cost, 2, ',', ' '));

                if ($('#cart-info').length != 1) {
                    $('#header-search').after('<a href="/cart" class="e-btn-enter" id="cart-info"></a>');
                }
                $('#cart-info').text('Оформить (' + data.count + ')');
                if (!link.hasClass('active')) {
                    link.addClass('active');
                    link.addClass('e-remove');
                    // link.text('Добавлено');
                }
                if ($('#pl-confirm').css('display') == 'none')
                    $('#pl-confirm').show();
            }
        });
        return false;
    }).on('click', '.e-remove', function () {
        var code = $(this).parent().parent().find('input[name="code"]').val();
        var totalBlock = $(this).parent().parent().parent().parent().find('.total-cost');
        // var link = $(this);
        var link = $(this).parent().find('.btn-view.e-remove');

        var num = $(this).parent().find('.list-view_price').text();
        num = num.replace(/от/g, '');
        num = num.replace(/руб/g, '');
        num = num.replace(/\./g, '');
        num = num.replace(/\s/g, '');
        num = num.replace(/,/g, '.');
        var groupCost = totalBlock.text();
        groupCost = groupCost.replace(/от/g, '');
        groupCost = groupCost.replace(/руб/g, '');
        groupCost = groupCost.replace(/\./g, '');
        groupCost = groupCost.replace(/\s/g, '');
        groupCost = groupCost.replace(/,/g, '.');
        groupCost = groupCost - num;

        var serviceID = $(this).data('id');
        var optionElement = $('.selectpicker option[value="' + serviceID + '"]');
        var optionIndex = $('.selectpicker option').index(optionElement);

        if (optionIndex == -1) {
            $('.param.service-4.paramed .selectize-dropdown .option').removeClass('selected');
            $('.param.service-4.paramed .selectize-dropdown .option:first-child').click();
        } else {
            optionIndex += 2;
            var id = '.dropdown-menu #item_' + optionIndex;
            if ($(id).hasClass('selected')) {
                $(id).find('a').click();
            } else {
                $(id).removeClass('selected');
            }
            ;
        }

        $.ajax({
            'async': false,
            'global': false,
            'url': "/cart/remove",
            'method': "POST",
            'data': "code=" + code + "&_csrf=" + $("#_csrf").val(),
            'dataType': "json",
            'success': function (data) {

                totalBlock.text(number_format(groupCost, 2, ',', ' ') + ' руб.');

                var sum = 0;
                $('.total-cost').each(function () {
                    var num = $(this).html();
                    num = num.replace(/от/g, '');
                    num = num.replace(/руб/g, '');
                    num = num.replace(/\./g, '');
                    num = num.replace(/\s/g, '');
                    num = num.replace(/,/g, '.');
                    sum += Number(num)
                });

                $('.calc-price .b-inner strong').text(number_format(sum, 2, ',', ' ') + ' руб.');

                // $('.calc-price .b-inner strong').text(number_format(data.cost, 2, ',', ' '));

                var newSumm = parseFloat(link.parent().parent().next().find('.block-cost').text().replace(',', '.').replace(' ', ''));
                newSumm = newSumm - parseFloat(data.diff);
                link.parent().parent().next().find('.block-cost').text(number_format(newSumm, 2, ',', ' '));
                if ($('#cart-info').length != 1) {
                    $('#header-search').after('<a href="/cart" class="e-btn-enter" id="cart-info"></a>');
                }
                $('#cart-info').text('Оформить (' + data.count + ')');
                // link.parent().remove();
                if (link.hasClass('e-remove')) {
                    link.removeClass('active');
                    link.removeClass('e-remove');
                    // link.text('Добавлено');
                }
            }
        });

        return false;
    });

})(jQuery, window, document);

$(function () {

    $('#global-search').on('click', function (e) {
        var search = $(this).parent().parent().find('input[name=search]').val();
        if (search == '')
            return false;
        location.href = '/search?text=' + search;
    });

    if ($('body').hasClass('success-alert')) {
        $("[data-remodal-id=success]").remodal().open();
        setTimeout(function () {
            $("[data-remodal-id=success]").remodal().close()
        }, 6000);
        $('body').removeClass('success-alert')
    }

    setInterval(function () {
        if ($('body').hasClass('success-alert')) {
            $("[data-remodal-id=success]").remodal().open();
            setTimeout(function () {
                $("[data-remodal-id=success]").remodal().close()
            }, 6000);
            $('body').removeClass('success-alert')
        }
    }, 500);

});

$(window).on('load', function () {

    var i = 0;
    $(".bootstrap-select.btn-group .dropdown-menu > li").each(function () {
        i++;
        $(this).attr("id", "item_" + i);
    });
});

$(function () {
    $('.tabs li a').click(function () {
        $(this).parents('.tab-wrap').find('.tab-cont').addClass('hide-tab');
        $(this).parent().siblings().removeClass('active');
        var id = $(this).attr('href');
        $(id).removeClass('hide-tab');
        $(this).parent().addClass('active');
        $(window).resize();
        return false;
    });

    $('.add').click(function () {
        $(this).parents('li').addClass('added-line');
        var id = $(this).attr('href');
        if ($(id).hasClass('selected')) {
            $(id).addClass('selected');
        } else {
            $(id).find('a').click();
        }
        ;

        return false;
    });
    $('.added').click(function () {
        $(this).parents('li').removeClass('added-line');
        var id = $(this).attr('href');
        if ($(id).hasClass('selected')) {
            $(id).find('a').click();
        } else {
            $(id).removeClass('selected');
        }
        ;
        return false;
    });

    $('.btn-view.del').click(function () {

        var code = $(this).parent().parent().find('input[name="code"]').val();
        var totalBlock = $('.b-sum-order .sum-order_text span');
        var link = $(this);

        var num = $(this).parent().find('.list-view_price').text();
        num = num.replace(/от/g, '');
        num = num.replace(/руб/g, '');
        num = num.replace(/\./g, '');
        num = num.replace(/\s/g, '');
        num = num.replace(/,/g, '.');
        var groupCost = totalBlock.text();
        groupCost = groupCost.replace(/от/g, '');
        groupCost = groupCost.replace(/руб/g, '');
        groupCost = groupCost.replace(/\./g, '');
        groupCost = groupCost.replace(/\s/g, '');
        groupCost = groupCost.replace(/,/g, '.');
        groupCost = groupCost - num;

        $.ajax({
            'async': false,
            'global': false,
            'url': "/cart/remove",
            'method': "POST",
            'data': "code=" + code + "&_csrf=" + $("#_csrf").val(),
            'dataType': "json",
            'success': function (data) {

                totalBlock.text(number_format(groupCost, 2, ',', ' ') + ' руб.');

                var sum = 0;
                $('.total-cost').each(function () {
                    var num = $(this).html();
                    num = num.replace(/от/g, '');
                    num = num.replace(/руб/g, '');
                    num = num.replace(/\./g, '');
                    num = num.replace(/\s/g, '');
                    num = num.replace(/,/g, '.');
                    sum += Number(num)
                });
                if ($('#cart-info').length != 1) {
                    $('#header-search').after('<a href="/cart" class="e-btn-enter" id="cart-info"></a>');
                }
                $('#cart-info').text('Оформить (' + data.count + ')');
                if (link.parent().parent().parent().find('li').length == 1) {
                    link.parent().parent().parent().prev('h2').remove();
                }
            }
        });

        $(this).closest('.list-view_item').remove();
        return false;
    });

    $('#orderOnAddForm .dropdown-menu li:first-child').hide();

    // moved to calculator.js to eliminate duplicate events
    // $('#reset-calc').click(function () {
    //     $('#orderOnAddForm .selectize-dropdown .option').removeClass('selected');
    //
    //     $('#orderOnAddForm .selectpicker optgroup option:selected').removeAttr("selected");
    //     $('#orderOnAddForm .selectpicker optgroup option:selected').prop("selected", false);
    //
    //     $('#orderOnAddForm .selectize-dropdown .option:first-child').click();
    //     $('#orderOnAddForm .dropdown-menu li.selected').find('a').click();
    //     $('#orderOnAddForm .dropdown-menu li.selected').removeClass('selected');
    //     $('.service-3, .service-4').hide();
    //     document.getElementById('orderOnAddForm').reset();
    //     $('#orderOnAddForm .selectpicker optgroup option:selected').removeAttr("selected");
    //     $('#orderOnAddForm .selectpicker optgroup option:selected').prop("selected", false);
    //     $('#orderOnAddForm .selectpicker optgroup option:selected').removeAttr("selected");
    //     $('#orderOnAddForm .selectpicker optgroup option:selected').prop("selected", false);
    // });

    $('body').on('click', '.show-more-rows', function (event) {
        event.preventDefault();
        var id = $(this).attr('href'),
            text = $(this).text();
        $(id).find('.ext-row').slideToggle(500);
        if (text == 'Показать еще') {
            $(this).text('Скрыть');
        } else {
            $(this).text('Показать еще');
        }
    });

});

CReview = {
    init: function () {
        CReview.initEvent();
    },
    initEvent: function () {
        $('#reviews_form_show').on('click', function () {
            if (!$(this).hasClass('active')) {
                $('#formReviews').show();
                $(this).addClass('active').html('Скрыть отзыв');
            } else {
                $('#formReviews').hide();
                $(this).removeClass('active').html('Оставить отзыв');
            }
        });
        $('body').on('click', '.review-item .plus', function () {
            CReview.vote("1", $(this).closest('.rate').data('review_id'));
        });
        $('body').on('click', '.review-item .minus', function () {
            CReview.vote("-1", $(this).closest('.rate').data('review_id'));
        });
        $('body').on('click', '.review-item .answer', function () {
            // CReview.selectAnswer($(this).closest('.rate').data('review_id'), $(this).closest('.rate').data('name'));
            CReview.selectAnswer($(this));
        });
        $('body').on('click', '#formReviews .replay a', function () {
            CReview.removeSelectAnswer();
        });

        $('body').on('change', '[name="mark_id"]', function () {
            CReview.getMark($(this).val());
        });

        if ($('[name="mark_id"]').length)
            CReview.getMark($('[name="mark_id"]').val());

        CReview.validate();
    },
    getMark: function (id) {
        $("#review .model-list").html("");
        $.ajax({
            url: '/mark/model',
            type: "POST",
            dataType: "json",
            data: {
                id: id,
                _csrf: $('[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                $("#review .model-list").html(data.html);
                // $("#review .model-list select").selectpicker();

                $("#review .model-list select").selectize();
            },
            error: function (response) {
            }
        });
    },
    vote: function (val, review_id) {

        $.ajax({
            url: '/set-vote',
            type: "POST",
            dataType: "json",
            data: {
                val: val,
                review_id: review_id,
                _csrf: $('[name="csrf-token"]').attr('content')
            },
            self: self,
            success: function (data) {
                $('[data-review_id="' + data.review_id + '"]').find('.plus span').html(data.plus);
                $('[data-review_id="' + data.review_id + '"]').find('.minus span').html(data.minus);
            },
            error: function (response) {
            }
        });

    },
    selectAnswer: function (self) {

        $('.review-element #formReviewsReplay').remove();

        var id = self.closest('.rate').data('review_id');
        self.closest('.review-element').append($('.replay-block').html());

        setTimeout(function () {
            self.closest('.review-element').find('#review_id').val(id);
            CReview.validate();
        }, 300);
    },
    removeSelectAnswer: function () {
        $('#formReviews #review_id').val('');
        $('#formReviews .replay').hide();
    },
    validate: function () {

        $('#formReviewsReplay').validate({
            rules: {
                body: {
                    required: true,
                },
                name: {
                    required: true,
                }
            },
            messages: {
                body: {
                    required: "Обязательное поле",
                },
                name: {
                    required: "Обязательное поле",
                }
            }
        });
    }
};

$(function () {

    CReview.init();

    $('.m-result-table').on('click', '.table-cell a', function () {

        var name = "Добавить";
        var code = $(this).parent().parent().find('input[name="code"]').val();
        var totalBlock = $(this).parent().parent().parent().parent().find('.total-cost');
        var link = $(this).parent().find('.btn-view.e-remove');
        var num = $(this).parent().find('strong').text();

        num = num.replace(/от/g, '');
        num = num.replace(/руб/g, '');
        // num = num.replace(/\./g, '');
        num = num.replace(/\s/g, '');
        num = num.replace(/,/g, '.');

        var groupCost = $(this).parent().parent().parent().next().find('.price').text(); //totalBlock.text();
        // groupCost = groupCost.replace(/от/g, '');
        // groupCost = groupCost.replace(/руб/g, '');
        // groupCost = groupCost.replace(/\./g, '');
        groupCost = groupCost.replace(/\s/g, '');
        groupCost = groupCost.replace(/,/g, '.');

        var serviceID = $(this).data('id');
        var optionElement = $('.selectpicker option[value="' + serviceID + '"]');

        if ($(this).hasClass('added')) {

            groupCost = parseFloat(groupCost) - parseFloat(num);

            var optionIndex = $('.selectpicker option').index(optionElement);

            if (optionIndex == -1) {
                $('.param.service-4.paramed .selectize-dropdown .option').removeClass('selected');
                $('.param.service-4.paramed .selectize-dropdown .option:first-child').click();
            } else {
                optionIndex += 2;
                var id = '.dropdown-menu #item_' + optionIndex;
                if ($(id).hasClass('selected')) {
                    $(id).find('a').click();
                } else {
                    $(id).removeClass('selected');
                }
                ;
            }

            $.ajax({
                'async': false,
                'global': false,
                'url': "/cart/remove",
                'method': "POST",
                'data': "code=" + code + "&_csrf=" + $("#_csrf").val(),
                'dataType': "json",
                'success': function (data) {
                    var sum = 0;
                    $('.total-cost').each(function () {
                        var num = $(this).html();
                        num = num.replace(/от/g, '');
                        num = num.replace(/руб/g, '');
                        num = num.replace(/\./g, '');
                        num = num.replace(/\s/g, '');
                        num = num.replace(/,/g, '.');
                        sum += Number(num)
                    });

                    $('.calc-price .b-inner strong').text(number_format(sum, 2, ',', ' ') + ' руб.');

                    // $('.calc-price .b-inner strong').text(number_format(data.cost, 2, ',', ' '));

                    var newSumm = parseFloat(link.parent().parent().next().find('.block-cost').text().replace(',', '.').replace(' ', ''));
                    newSumm = newSumm - parseFloat(data.diff);
                    link.parent().parent().next().find('.block-cost').text(number_format(newSumm, 2, ',', ' '));
                    if ($('#cart-info').length != 1) {
                        $('#header-search').after('<a href="/cart" class="e-btn-enter" id="cart-info"></a>');
                    }
                    $('#cart-info').text('Оформить (' + data.count + ')');

                }
            });
        } else {

            name = "Добавлено";

            groupCost = parseFloat(groupCost) + parseFloat(num);

            var optionIndex = $('.selectpicker option').index(optionElement) + 2;

            var id = '.dropdown-menu #item_' + optionIndex;

            if ($(id).hasClass('selected')) {
                $(id).addClass('selected');
            } else {
                $(id).find('a').click();
            }
            ;

            $.ajax({
                'async': false,
                'global': false,
                'url': "/cart/add",
                'method': "POST",
                'data': "code=" + code + "&_csrf=" + $("#_csrf").val(),
                'dataType': "json",
                'success': function (data) {
                    totalBlock.text(number_format(groupCost, 2, ',', ' ') + ' руб.');

                    var sum = 0;
                    $('.total-cost').each(function () {
                        var num = $(this).html();
                        num = num.replace(/от/g, '');
                        num = num.replace(/руб/g, '');
                        num = num.replace(/\./g, '');
                        num = num.replace(/\s/g, '');
                        num = num.replace(/,/g, '.');
                        sum += Number(num)
                    });

                    $('.calc-price .b-inner strong').text(number_format(sum, 2, ',', ' ') + ' руб.');

                    // $('.calc-price .b-inner strong').text(number_format(data.cost, 2, ',', ' '));

                    if ($('#cart-info').length != 1) {
                        $('#header-search').after('<a href="/cart" class="e-btn-enter" id="cart-info"></a>');
                    }
                    $('#cart-info').text('Оформить (' + data.count + ')');

                    if ($('#pl-confirm').css('display') == 'none')
                        $('#pl-confirm').show();
                }
            });
        }

        $(this).parent().parent().parent().next().find('.price').text(number_format(groupCost, 2, ',', ' '));
        $(this).toggleClass('added');
        $(this).text(name);
        return false;
    });

    $('.m-work-list .master').on('click', 'a.master-link', function () {
        return false;
    })

    $('.m-work-list').on('click', 'a.show-form', function () {
        $(this).closest('form').css({'display': 'block'});
        $(this).next('fieldset').show('');
        return false;
    })

    // $('.m-work-list').on('click', 'a.cls', function() {
    //     $(this).closest('fieldset').hide();
    //     $(this).closest('form').css({'display':'none'});
    //     return false;
    // })

    $(document).click(function (event) {
        if ($(event.target).closest(".master").length) return;
        $('.master fieldset').hide();
        $('.master form').css({'display': 'none'});
        event.stopPropagation();
    });

    var m = $('.n1');
    $('.m-form').on('click', '.clear', function () {
        $('.m-form').find('form')[0].reset();

        $('select').multipleSelect('refresh');
        $('select').multipleSelect('disable');

        m.data('multipleSelect').$parent.remove();
        m.removeData('multipleSelect');
        m.show();

        $('.n1').multipleSelect({
            placeholder: $(this).data('placeholder'),
            single: true,
            onClick: function (v) {
                $('.m-form form').css({'background-image': 'url(/images/content/mark/' + v.value + '.png)'});
            },
            onClose: function () {
                _destroy('.n2');
                $('.n2').multipleSelect({
                    placeholder: $(this).data('placeholder'),
                    single: true,
                    onClose: function () {
                        _nextEnable(3)
                    }
                });
            }
        });

        return false;
    })

    $('.b-header_menu').on('click', '.show-all', function () {
        $(this).closest('.header-menu-block').toggleClass('open')
        return false
    })

    var menuFunc = function () {
        if ($(document).width() > 1099) {
            $('.static-item').hover(function () {
                $('body').css({'overflow': 'hidden'})
                $('.services-menu').css({'height': $(window).height()})
            }, function () {
                $('body').css({'overflow': 'scroll'})
            })
        }
    }

    menuFunc();

    $(window).on('resize', function () {
        menuFunc();
    })

    $('.header-menu-block').find('ul').map(function (i) {
        $(this).children().hide()
    })

    $('#maintenance_modify_select').on("change", function () {
        var cur_mod = $(this).val();

        $('.maintenance_block').each(function () {
            if ($(this).data("modification") == cur_mod) {
                $(this).removeClass("hidden");
            } else {
                $(this).addClass("hidden");
            }
        });
    });

    $('.selectpicker').selectpicker({noneSelectedText: 'Выберите услугу'});

    $('#orderOnAddCity').on('change', function () {
        if ($(this).val() == 0)
            $('#city-name').removeClass('hidden');
        else if (!$('#city-name').hasClass('hidden'))
            $('#city-name').addClass('hidden');
    });
});
